// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2UpCB","label":"Section_label__29aeg","contentWrap":"Section_contentWrap__iq3_-","footer":"Section_footer__1-LDZ","footerInner":"Section_footerInner__1wV4r"};